import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { getOrgId } from "./orgHelpers";
import { SupplierReceiptsService } from "../services/SupplierReceiptsService";
import { CreateSupplierReceiptPayload, ISupplierReceipt } from "../models/SupplierReceipts";
import { openToast } from "./ToastSlice";

interface SupplierReceiptsState {
    list:           Array<ISupplierReceipt> | null;
    modalAddStatus: boolean;
    creating:       boolean;
    loadingResults: boolean;
}

const initialState: SupplierReceiptsState = {
    list:           null,
    modalAddStatus: false,
    creating:       false,
    loadingResults: false,
};

const slice = createSlice({
    name: "supplierReceipts",
    initialState,
    reducers: {
        setList           (state, action: PayloadAction<Array<ISupplierReceipt>>) { state.list           = action.payload; },
        setModalAddStatus (state, action: PayloadAction<boolean>)                 { state.modalAddStatus = action.payload; },
        setCreating       (state, action: PayloadAction<boolean>)                 { state.creating       = action.payload; },
        setLoadingResults (state, action: PayloadAction<boolean>)                 { state.loadingResults = action.payload; },
    },
});

export const {
    setList,
    setModalAddStatus,
    setCreating,
    setLoadingResults,
} = slice.actions;

export default slice.reducer;

export const fetchSupplierReceipts = (): AppThunk<Promise<void>> => async (dispatch, getState) => {
    dispatch(setLoadingResults(true));
    try {
        const id = getOrgId(getState());
        const data = await SupplierReceiptsService.getByOrganization(id);
        dispatch(setList(data));
    } catch (e) {
        console.error('fetchSupplierReceipts error', e);
    } finally {
        dispatch(setLoadingResults(false));
    }
};

export const createSupplierReceipt = (form: { supplier_id: number; asset_id: number; value: string; hash?: string }): AppThunk<Promise<void>> => async (dispatch, getState) => {
    dispatch(setCreating(true));
    try {
        const id = getOrgId(getState());
        const payload: CreateSupplierReceiptPayload = {
            supplier_id:     form.supplier_id,
            asset_id:        form.asset_id,
            organization_id: id,
            value:           form.value,
            ...(form.hash ? { hash: form.hash } : {}),
        };
        await SupplierReceiptsService.create(payload);

        dispatch(openToast({ title: 'Recebimento', message: 'Recebimento registrado com sucesso', effect: 'success' }));
        dispatch(setModalAddStatus(false));
        dispatch(fetchSupplierReceipts());
    } catch (e: any) {
        dispatch(openToast({ title: 'Erro', message: e?.message ?? 'Falha ao registrar recebimento', effect: 'error' }));
        console.error('createSupplierReceipt error', e);
    } finally {
        dispatch(setCreating(false));
    }
};
